import React from 'react';
import { SlashCircleFill, EnvelopeFill } from 'react-bootstrap-icons';
import { useLocale } from '../i18n/LocaleContext';
import { SUPPORT_EMAIL } from '../pages/embedProblems';
import './ShopifyConnectionBanner.scss';

// Outfino suspended the brand (the API's admin-only brands.admin_suspended,
// set in the admin panel): the brand is hidden from the app and the fit-check
// button whatever its own "A márka látható az Outfinóban" switch says, and
// the portal cannot lift it. Shown on every page of the brand, always (no
// flag) — the session brand carries `adminSuspended` (GET /user/me stores[]);
// an older API never sends it, so nothing shows there.
export function isBrandSuspended(brand) {
  return !!brand && brand.adminSuspended === true;
}

export default function BrandSuspendedBanner({ brand }) {
  const { t } = useLocale();
  if (!isBrandSuspended(brand)) return null;
  const subject = `${t('brandSuspended.mailSubject')}: ${brand.name || ''}`;
  return (
    <div className="conn-banner conn-banner--error" role="alert" data-status="BRAND_SUSPENDED" data-testid="brand-suspended-banner">
      <span className="conn-banner__icon" aria-hidden="true">
        <SlashCircleFill size={16} />
      </span>
      <div className="conn-banner__text">
        <div className="conn-banner__title">{t('brandSuspended.title')}</div>
        <div className="conn-banner__meta">
          <span className="conn-banner__reason">{t('brandSuspended.body')}</span>
        </div>
      </div>
      <a className="conn-banner__cta" href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`}>
        <EnvelopeFill size={14} aria-hidden="true" />
        <span>{t('brandSuspended.cta')}</span>
      </a>
    </div>
  );
}
